// Common
import './lib/common/common.js';

// Load Web components
import '../components/kw-button-languages/kw-button-languages.js';
import '../components/kw-footer/kw-footer.js';
import '../components/kw-header/kw-header.js';
import '../components/kw-banner/kw-banner.js';
import '../components/kw-title/kw-title.js';
import '../components/kw-section/kw-section.js';

// Load libraries
import './lib/scroll/scroll.js';

import DataLanguage from './lib/data-language.js';
import dataBanner from './lib/dataBanner.js';
import dataBanners from '../json/bannerInternalTrainingData.json';

const { lang } = document.querySelector('html');

function banner() {
  const bannerData = document.getElementById('banner-internal-training');
  bannerData.innerHTML = `
            <kw-banner id="Banner" banner-size="internalTraining" animation-type="slide-toleft" change-interval="8">
                ${DataLanguage.dataLanguage(dataBanners.bannerInternalTrainingData, lang).map(dataBanner.banner).join('')}
            </kw-banner>
      `;
}

/* eslint-disable-next-line */
window.onload = function () {
  banner();
};
